function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRef } from "react";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { useUnmount } from "ahooks";
import classnames from "classnames";
import { CloseFillIcon, CopyFillIcon, ReloadIcon, PlusIcon } from "@t8891/icon";
import PreviewItem from "./preview-item";
import { FileItem, Upload, UploadOptions } from "./data";
import Loading from "../loading";
import ProgressBar from "../progress-bar";
import ImageViewer from "../image-viewer";
import { mergeProps } from "../../utils/mergeProps";
import { withNativeProps } from "../../utils/with-native-props";
var classPrefix = "tc-uploader";
var defaultProps = {
  autoUpload: true,
  name: "file",
  defaultValue: [],
  showPreview: true,
  defaultImg: "",
  isDeletable: true,
  deleteIcon: /*#__PURE__*/React.createElement(CloseFillIcon, {
    size: 48
  }),
  uploadIcon: /*#__PURE__*/React.createElement(PlusIcon, {
    size: 48
  }),
  failIcon: /*#__PURE__*/React.createElement(ReloadIcon, {
    size: 48
  }),
  method: "post",
  listType: "picture",
  capture: false,
  imageFit: "cover",
  maxCount: 99,
  maximize: Number.MAX_VALUE,
  clearInput: true,
  accept: "*",
  headers: {},
  data: {},
  disabledUpload: false,
  isPreview: true,
  showFailed: true,
  showUpload: true,
  xhrState: 200,
  withCredentials: false,
  multiple: true,
  disabled: false,
  timeout: 1000 * 30,
  onBeforeDelete: function onBeforeDelete() {
    return true;
  }
};
var InternalUploader = function InternalUploader(p, ref) {
  var props = mergeProps(defaultProps, p);
  var children = props.children,
    maxCount = props.maxCount,
    capture = props.capture,
    name = props.name,
    accept = props.accept,
    disabled = props.disabled,
    listType = props.listType,
    defaultFileList = props.defaultFileList,
    isPreview = props.isPreview,
    defaultImg = props.defaultImg,
    onOversize = props.onOversize,
    className = props.className,
    autoUpload = props.autoUpload,
    data = props.data,
    withCredentials = props.withCredentials,
    url = props.url,
    headers = props.headers,
    xhrState = props.xhrState,
    method = props.method,
    clearInput = props.clearInput,
    isDeletable = props.isDeletable,
    loadingTips = props.loadingTips,
    _props$loadingIcon = props.loadingIcon,
    loadingIcon = _props$loadingIcon === void 0 ? /*#__PURE__*/React.createElement(Loading, {
      isLoading: true,
      size: 'small',
      customTheme: '#FFF'
    }) : _props$loadingIcon,
    iconAttribute = props.iconAttribute,
    timeout = props.timeout,
    multiple = props.multiple,
    imageFit = props.imageFit,
    deleteIcon = props.deleteIcon,
    renderItem = props.renderItem,
    uploadIcon = props.uploadIcon,
    failIcon = props.failIcon,
    failTips = props.failTips,
    showPreview = props.showPreview,
    onPreview = props.onPreview,
    onStart = props.onStart,
    onChange = props.onChange,
    onProgress = props.onProgress,
    onBeforeDelete = props.onBeforeDelete,
    onBeforeXhrUpload = props.onBeforeXhrUpload,
    onSuccess = props.onSuccess,
    onRemove = props.onRemove,
    onBeforeUpload = props.onBeforeUpload,
    onFileItemClick = props.onFileItemClick,
    onFailure = props.onFailure;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    fileList = _useState2[0],
    setFileList = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    fileCurrent = _useState4[0],
    setFileCurrent = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    uploadQueue = _useState6[0],
    setUploadQueue = _useState6[1];
  var baseProps = {
    className: classnames(classPrefix, className)
  };
  useEffect(function () {
    if (defaultFileList) {
      setFileList(defaultFileList);
    }
  }, [defaultFileList]);
  useImperativeHandle(ref, function () {
    return {
      // submit
      submit: function submit() {
        Promise.all(uploadQueue).then(function (res) {
          res.forEach(function (i) {
            return i.upload();
          });
        });
      },
      clear: function clear() {
        setFileList([]);
        setUploadQueue([]);
      }
    };
  });
  /** 清空队列 */
  var clearUploadQueue = function clearUploadQueue() {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    if (index > -1) {
      uploadQueue.splice(index, 1);
      setUploadQueue(uploadQueue);
    } else {
      setUploadQueue([]);
    }
  };
  /** 清空输入值 */
  var clearInputValue = function clearInputValue(el) {
    el.value = "";
  };
  /** 执行上传 */
  var executeUpload = function executeUpload(fileItem, index) {
    var uploadOption = new UploadOptions();
    uploadOption.url = url || "";
    for (var _i2 = 0, _Object$entries = Object.entries(data); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      fileItem.formData.append(key, value);
    }
    uploadOption.formData = fileItem.formData;
    uploadOption.timeout = timeout * 1;
    uploadOption.method = method;
    uploadOption.xhrState = xhrState;
    uploadOption.headers = headers;
    uploadOption.withCredentials = withCredentials;
    uploadOption.beforeXhrUpload = onBeforeXhrUpload;
    try {
      uploadOption.sourceFile = fileItem.formData.get(name);
    } catch (error) {}
    uploadOption.onStart = function (option) {
      clearUploadQueue(index);
      setFileList(function (prevFileList) {
        prevFileList.map(function (item) {
          if (item.uid === fileItem.uid) {
            item.status = "ready";
            item.message = "ready";
          }
          return item;
        });
        return _toConsumableArray(prevFileList);
      });
      onStart === null || onStart === void 0 ? void 0 : onStart(option);
    };
    uploadOption.onProgress = function (e, option) {
      setFileList(function (prevFileList) {
        prevFileList.map(function (item) {
          if (item.uid === fileItem.uid) {
            item.status = "uploading";
            item.message = "uploading";
            item.percentage = (e.loaded / e.total * 100).toFixed(0);
            onProgress === null || onProgress === void 0 ? void 0 : onProgress({
              e: e,
              option: option,
              percentage: item.percentage
            });
          }
          return item;
        });
        return _toConsumableArray(prevFileList);
      });
    };
    uploadOption.onSuccess = function (responseText, option) {
      setFileList(function (prevFileList) {
        prevFileList.map(function (item) {
          if (item.uid === fileItem.uid) {
            item.status = "success";
            item.message = "success";
          }
          return item;
        });
        return _toConsumableArray(prevFileList);
      });
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
        responseText: responseText,
        option: option
      });
    };
    uploadOption.onFailure = function (responseText, option) {
      setFileList(function (prevFileList) {
        prevFileList.map(function (item) {
          if (item.uid === fileItem.uid) {
            item.status = "error";
            item.message = "error";
          }
          return item;
        });
        return _toConsumableArray(prevFileList);
      });
      onFailure === null || onFailure === void 0 ? void 0 : onFailure({
        responseText: responseText,
        option: option
      });
    };
    var task = new Upload(uploadOption);
    if (autoUpload) {
      task.upload();
    } else {
      uploadQueue.push(new Promise(function (resolve) {
        resolve(task);
      }));
      setUploadQueue(uploadQueue);
    }
  };
  /** 重新执行上传 */
  var reSetExecuteUpload = function reSetExecuteUpload(fileItem, index) {
    var uploadOption = new UploadOptions();
    uploadOption.url = url || "";
    for (var _i3 = 0, _Object$entries2 = Object.entries(data); _i3 < _Object$entries2.length; _i3++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];
      fileItem.formData.append(key, value);
    }
    uploadOption.formData = fileItem.formData;
    uploadOption.timeout = timeout * 1;
    uploadOption.method = method;
    uploadOption.xhrState = xhrState;
    uploadOption.headers = headers;
    uploadOption.withCredentials = withCredentials;
    uploadOption.beforeXhrUpload = onBeforeXhrUpload;
    try {
      uploadOption.sourceFile = fileItem.formData.get(name);
    } catch (error) {}
    uploadOption.onStart = function (option) {
      var arr = _toConsumableArray(fileList);
      arr[index].status = "uploading";
      arr[index].message = "uploading";
      setFileList(arr);
      onStart === null || onStart === void 0 ? void 0 : onStart(option);
    };
    uploadOption.onSuccess = function (responseText, option) {
      var arr = _toConsumableArray(fileList);
      arr[index].status = "success";
      arr[index].message = "success";
      setFileList(arr);
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
        responseText: responseText,
        option: option
      });
    };
    uploadOption.onFailure = function (responseText, option) {
      var arr = _toConsumableArray(fileList);
      arr[index].status = "error";
      arr[index].message = "error";
      setFileList(arr);
      onFailure === null || onFailure === void 0 ? void 0 : onFailure({
        responseText: responseText,
        option: option
      });
    };
    var task = new Upload(uploadOption);
    if (autoUpload) {
      task.upload();
    } else {
      uploadQueue.push(new Promise(function (resolve) {
        resolve(task);
      }));
      setUploadQueue(uploadQueue);
    }
  };
  /** 文件读取处理 */
  var readFile = function readFile(files) {
    files.forEach(function (file, index) {
      var formData = new FormData();
      formData.append(name, file);
      var fileItem = new FileItem();
      fileItem.name = file.name;
      fileItem.status = "ready";
      fileItem.type = file.type;
      fileItem.formData = formData;
      fileItem.uid = file.lastModified + fileItem.uid;
      fileItem.message = "ready";
      executeUpload(fileItem, index);
      if (isPreview && file.type.includes("image")) {
        var reader = new FileReader();
        reader.onload = function (event) {
          fileItem.url = event.target.result;
          fileList.push(fileItem);
          setFileList(_toConsumableArray(fileList));
        };
        reader.readAsDataURL(file);
      } else {
        fileList.push(fileItem);
        setFileList(_toConsumableArray(fileList));
      }
    });
  };
  /** 文件读取处理 */
  var reSetReadFile = function reSetReadFile(index) {
    var file = fileCurrent[0];
    var formData = new FormData();
    formData.append(name, file);
    var fileItem = new FileItem();
    fileItem.name = file.name;
    fileItem.status = "ready";
    fileItem.type = file.type;
    fileItem.formData = formData;
    fileItem.uid = file.lastModified + fileItem.uid;
    fileItem.message = "ready";
    reSetExecuteUpload(fileItem, index);
  };
  /** 图片过滤处理 */
  var filterFiles = function filterFiles(files) {
    var maximize = props.maximize * 1;
    var oversizes = new Array();
    var filterFile = files.filter(function (file) {
      if (file.size > maximize) {
        oversizes.push(file);
        return false;
      }
      return true;
    });
    if (oversizes.length) {
      onOversize === null || onOversize === void 0 ? void 0 : onOversize(files);
    }
    if (filterFile.length > maximize) {
      filterFile.splice(maximize, filterFile.length - maximize);
    }
    if (fileList.length !== 0) {
      var index = maximize - fileList.length;
      filterFile.splice(index, filterFile.length - index);
    }
    return filterFile;
  };
  /** 删除 */
  var onDelete = function onDelete(file, index) {
    clearUploadQueue(index);
    if (onBeforeDelete === null || onBeforeDelete === void 0 ? void 0 : onBeforeDelete(file, fileList, index)) {
      fileList.splice(index, 1);
      onRemove === null || onRemove === void 0 ? void 0 : onRemove(file, fileList);
      setFileList(_toConsumableArray(fileList));
    }
  };
  /** 文件变动 */
  var fileChange = function fileChange(event) {
    if (disabled) return;
    var $el = event.target;
    var files = $el.files;
    if (onBeforeUpload) {
      onBeforeUpload(new Array().slice.call(files)).then(function (f) {
        var _files = filterFiles(new Array().slice.call(f));
        setFileCurrent(_files);
        readFile(_files);
      });
    } else {
      var _files = filterFiles(new Array().slice.call(files));
      setFileCurrent(_files);
      readFile(_files);
    }
    onChange === null || onChange === void 0 ? void 0 : onChange({
      fileList: fileList,
      event: event
    });
    if (clearInput) {
      clearInputValue($el);
    }
  };
  var imageViewerHandlerRef = useRef(null);
  function previewImage(index) {
    imageViewerHandlerRef.current = ImageViewer.Multi.show({
      images: fileList.map(function (fileItem) {
        return fileItem.url;
      }),
      defaultIndex: index,
      onClose: function onClose() {
        imageViewerHandlerRef.current = null;
      }
    });
  }
  var handleItemClick = function handleItemClick(file) {
    onFileItemClick === null || onFileItemClick === void 0 ? void 0 : onFileItemClick(file);
  };
  useUnmount(function () {
    var _a;
    (_a = imageViewerHandlerRef.current) === null || _a === void 0 ? void 0 : _a.close();
  });
  var renderImages = function renderImages(fileItem, index) {
    var _a;
    var originNode = /*#__PURE__*/React.createElement(PreviewItem, {
      key: (_a = fileItem.uid) !== null && _a !== void 0 ? _a : index,
      url: fileItem.url,
      deletable: !!isDeletable,
      deleteIcon: deleteIcon,
      loadingTips: loadingTips,
      loadingIcon: loadingIcon,
      failIcon: failIcon,
      failTips: failTips,
      status: fileItem.status,
      imageFit: imageFit,
      onReSet: function onReSet() {
        reSetReadFile(index);
      },
      onClick: function onClick() {
        if (showPreview) {
          previewImage(index);
        }
        onPreview === null || onPreview === void 0 ? void 0 : onPreview(index, fileItem);
      }
    });
    return renderItem ? renderItem(originNode, fileItem, fileItem) : originNode;
  };
  var renderImageLists = function renderImageLists() {
    return fileList.length !== 0 && fileList.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview ").concat(listType),
        key: item.uid
      }, listType === "picture" && !children && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview-img")
      }, item.status === "ready" ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview__progress")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview__progress__msg")
      }, item.message)) : item.status !== "success" && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview__progress")
      }, item.status === "error" ? /*#__PURE__*/React.createElement(CloseFillIcon, Object.assign({
        size: 24,
        fill: "#fff"
      }, iconAttribute)) : /*#__PURE__*/React.createElement(Loading, Object.assign({
        isLoading: true,
        size: 'small'
      }, iconAttribute)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview__progress__msg")
      }, item.message)), isDeletable && /*#__PURE__*/React.createElement(CloseFillIcon, {
        size: 32,
        fill: "#333",
        className: 'close',
        onClick: function onClick() {
          return onDelete(item, index);
        }
      }), item.type.includes("image") ? /*#__PURE__*/React.createElement(React.Fragment, null, renderImages(item, index)) : /*#__PURE__*/React.createElement(React.Fragment, null, defaultImg ? /*#__PURE__*/React.createElement("img", {
        className: "".concat(classPrefix, "__preview-img__c"),
        src: defaultImg,
        style: {
          objectFit: imageFit
        },
        onClick: function onClick() {
          return handleItemClick(item);
        }
      }) : /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview-img__file")
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return handleItemClick(item);
        },
        className: "".concat(classPrefix, "__preview-img__file__name")
      }, item.name)), /*#__PURE__*/React.createElement("div", {
        className: 'tips'
      }, item.name))), listType === "list" && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview-list")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview-img__file__name ").concat(item.status),
        onClick: function onClick() {
          handleItemClick(item);
        }
      }, /*#__PURE__*/React.createElement(CopyFillIcon, {
        size: 32,
        fill: item.status === "error" ? "#ff4333" : item.status === "success" ? "#00A969" : "#808080"
      }), item.name), item.status === "uploading" && /*#__PURE__*/React.createElement("div", {
        className: "".concat(classPrefix, "__preview-list-percentage")
      }, /*#__PURE__*/React.createElement(ProgressBar, {
        percent: item.percentage,
        text: false,
        style: {
          "--progress-bar-line-width": "2px"
        }
      }))));
    });
  };
  var inputComp = capture ? /*#__PURE__*/React.createElement("input", {
    className: "".concat(classPrefix, "__input"),
    type: 'file',
    capture: 'user',
    name: name,
    accept: accept,
    disabled: disabled,
    multiple: multiple,
    onChange: fileChange
  }) : /*#__PURE__*/React.createElement("input", {
    className: "".concat(classPrefix, "__input"),
    type: 'file',
    name: name,
    accept: accept,
    disabled: disabled,
    multiple: multiple,
    onChange: fileChange
  });
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), children && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "__slot")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children, !!maxCount && maxCount > fileList.length && /*#__PURE__*/React.createElement(React.Fragment, null, inputComp))), renderImageLists(), !!maxCount && maxCount > fileList.length && listType === "picture" && !children && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "__upload ").concat(listType)
  }, uploadIcon, inputComp)));
};
var Uploader = /*#__PURE__*/React.forwardRef(InternalUploader);
Uploader.defaultProps = defaultProps;
export default Uploader;